import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LandingPage } from '../../models';

import * as fromStore from '../../store';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingPageComponent implements OnInit {
  landingPage$!: Observable<LandingPage>;
  headerHasSkewBottom = false;
  constructor(private store: Store) {}

  ngOnInit(): void {
    this.landingPage$ = this.store.select(fromStore.getSelectedLandingPage);
    this.landingPage$.subscribe(page => {
      console.log(page);
      this.headerHasSkewBottom = !!page?.contentBlocks?.length && page.contentBlocks[0].blockType === 'default';
    });
  }

  hasHeader(obj: any) {
    return Object.values(obj).every(value => !!value) || !!obj?.image?.url;
  }
}
